import _Model from "./_Model";

export default class Protocol extends _Model {
  constructor(json) {
    super(json);
    this.name = Protocol.getOrDefault(json, 'name', '');
  }
}
